import { useTranslation } from "react-i18next";
import { WalletIcon } from "../../../../assets/icons/Icons";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../LinkTypes";
import { BaseComplexSidebarLink, ComplexLinkProps } from "./BaseComplexSidebarLink";
import { FC, useEffect, useMemo } from "react";
import { useWalletList } from "../../../../store/selectors/walletSelector";
import { fetchWalletListThunk } from "../../../../store/thunk/walletThunk";
import { useAppDispatch } from "../../../../hooks/StoreHooks";

export const WalletComplexLink: FC<ComplexLinkProps> = ({ activePathname, collapsed, showText }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const walletList = useWalletList();

    useEffect(() => {
        if (!walletList || walletList.length === 0) {
            dispatch(fetchWalletListThunk());
        }
    }, [walletList, dispatch]);
    const walletId = walletList?.[0]?.id;

    const links = useMemo(() => {
        const walletTypesLink = {
            linkName: SidebarLinkTypes.walletTypes,
            path: SidebarLinkPathTypes.walletTypes,
        };
        if (walletId) {
            return [
                {
                    linkName: SidebarLinkTypes.transactions,
                    path: `wallet/${walletId}/transactions`,
                },
                walletTypesLink,
            ];
        }
        return [
            {
                linkName: SidebarLinkTypes.transactions,
                path: "",
            },
            walletTypesLink,
        ];
    }, [walletId]);

    return (
        <BaseComplexSidebarLink
            activePathname={activePathname}
            collapsed={collapsed}
            showText={showText}
            icon={<WalletIcon color="white" />}
            label={t(SidebarLinkTypes.wallet)}
            links={links}
            mainPath={SidebarLinkPathTypes.wallet}
        />
    );
};